import { getCuratorShopLink } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type GetCuratorShopLinkServiceRequest,
  GetCuratorShopLinkServiceRequestDtoSchema,
  type GetCuratorShopLinkServiceResponse,
  GetCuratorShopLinkServiceResponseDtoSchema,
} from './get-curator-shop-link.dto';

export const getCuratorShopLinkService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetCuratorShopLinkServiceRequestDtoSchema),
    async (
      request: GetCuratorShopLinkServiceRequest,
    ): Promise<GetCuratorShopLinkServiceResponse> => {
      const response = await getCuratorShopLink(request);
      return response.data;
    },
    validateServiceResponse(GetCuratorShopLinkServiceResponseDtoSchema),
  ),
);
